import './al-navigation-main/component'
import './al-navigation-tabs/component'



// WEBPACK FOOTER //
// ./src/app/modules/navigation/components/index.js